module.exports = __webpack_public_path__ + "static/media/cafe_te.f72d579d.jpg";